const COLORS = {
  blue: '#2F2F5B',
  green: '#65C792',
  gray: '#F2F2F2',
  darkGray:'#5F6767',
}

export default COLORS